import React, { useEffect } from "react";
import { useQuery } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import Auth from "../utils/auth";
import GoogleButton from "../components/GoogleButton/GoogleButton.js";
import { QUERY_SYSTEM_SETTING } from "../utils/graphql/systemSettings/queries";
import { URLS } from "../config/urls";

const Login = () => {
  const navigate = useNavigate();
  const { data: googleIntegrationSettingData } = useQuery(QUERY_SYSTEM_SETTING, {
    variables: { key: "googleWorkspaceIntegrationEnabled" },
  });
  const googleWorkspaceIntegrationEnabled =
    String(googleIntegrationSettingData?.systemSetting?.value ?? "true").toLowerCase() !== "false";

  // ✅ Handle token returned from Google OAuth
  useEffect(() => {
    const hash = window.location.hash || "";
    const search = window.location.search || "";

    let token = null;
    if (hash.includes("token=")) {
      const afterHash = hash.startsWith("#") ? hash.slice(1) : hash;
      const queryPart = afterHash.includes("?")
        ? afterHash.split("?")[1]
        : afterHash;
      const params = new URLSearchParams(queryPart);
      token = params.get("token");
    } else if (search.includes("token=")) {
      const params = new URLSearchParams(search);
      token = params.get("token");
    }

    if (token) {
      Auth.login(token);
      navigate("/");
    }
  }, [navigate]);

  const hash = window.location.hash || "";
  const googleDisabledFromRedirect = hash.includes("google_integration_disabled");

  return (
    <main className="flex-row justify-center mb-4">
      <div className="col-12 col-md-6">
        <div style={{ textAlign: "center", marginTop: "4rem" }}>
          <h2>Welcome to Substitute Finder</h2>
          <p>Please sign in:</p>
          {!googleWorkspaceIntegrationEnabled || googleDisabledFromRedirect ? (
            <div className="alert alert-warning" role="alert">
              Google sign-in is currently disabled by an administrator.
            </div>
          ) : (
            <GoogleButton onClick={() => window.location.href = URLS.googleAuth} />
          )}
        </div>
      </div>
    </main>
  );
};

export default Login;